import { useState, useEffect } from "react";
import axios from "axios";
import { UPCOMING_EDITION, PRICE_PER_DAY } from "@/data/siteData";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useUpcomingEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/events/upcoming`)
      .then((res) => setEvents(res.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const hasEvents = events.length > 0;
  const dates = hasEvents ? events.map((e) => e.date_label) : UPCOMING_EDITION.dates;
  const dateRange = hasEvents ? events.map((e) => e.date_label).join(" & ") : UPCOMING_EDITION.dateRange;
  const venueName = hasEvents ? events[0].venue_name : UPCOMING_EDITION.venue;
  const prices = hasEvents ? events.map((e) => e.price_per_day) : [PRICE_PER_DAY];
  const minPrice = Math.min(...prices);
  const maxPrice = Math.max(...prices);

  return { events, loading, hasEvents, dates, dateRange, venueName, minPrice, maxPrice };
};
